import { Component, OnInit } from '@angular/core';
import Utilities from '@app/_helpers/utilities';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { HealthAddTagComponent } from '../health-add-tag/health-add-tag.component';
import { HealthService } from '@app/services/health/health.service';
import { Tag, HealthArticle, Promoter } from '@app/_models/health';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Location } from '@angular/common';
import { HealthAddPromoterComponent } from '../health-add-promoter/health-add-promoter.component';
@Component({
  selector: 'health-detail',
  templateUrl: './health-detail.component.html',
  styleUrls: ['./health-detail.component.scss'],
})
export class HealthDetailComponent implements OnInit {
  constructor(
    private _builder: FormBuilder,
    private _dialog: MatDialog,
    private _healthService: HealthService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _location: Location
  ) { }
  healthForm = this._builder.group({
    title: ['', Validators.required],
    content: ['', Validators.required],
    image: ['', Validators.required],
    status: ['', Validators.required],
  });
  tags: Tag[] = [];
  promoters: Promoter[] = [];
  newImgPreview: string;
  currentId: number;

  ngOnInit(): void {
    this.currentId = this._activatedRoute.snapshot.params.id;
    if (this.currentId) {
      this._healthService
        .getArticle(this.currentId)
        .subscribe((article: HealthArticle) => {
          this.healthForm.patchValue({
            title: article.title,
            content: article.content,
            status: article.status ? true : false,
          });
          fetch(
            article.image
          )
            .then(res => res.blob()) // Gets the response and returns it as a blob
            .then(blob => {
              const file = new File([blob], 'image.png', {
                type: 'image/png',
              });
              this.handleNewImgUpload(file);
            });
          this._healthService
            .getTagsByArticleId(this.currentId)
            .subscribe(tags => {
              this.tags = tags;
            });
          this._healthService
            .getPromotersByArticleId(this.currentId)
            .subscribe(promoters => {
              this.promoters = promoters;
            });
        });
    }
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
  }

  uploadNewHealthItemImg(): void {
    document.getElementById('healthItemFileInput').click();
  }
  async handleNewImgUpload(file: File): Promise<string> {
    this.newImgPreview = await Utilities.toBase64(file);
    this.healthForm.patchValue({
      image: file,
    });
    return '';
  }

  addTag(): void {
    const dialogRef = this._dialog.open(HealthAddTagComponent, {
      width: '800px',
    });
    const sub = dialogRef.componentInstance.onAddedTag.subscribe((tag: Tag) => {
      const isTagAdded = this.tags.findIndex((e) => {
        return e.id === tag.id;
      });
      if (isTagAdded === -1) {
        this.tags.push(tag);
      }
      dialogRef.close();
    });
    dialogRef.afterClosed().subscribe(() => {
      sub.unsubscribe();
    });
  }

  saveHealthDetail(ev: Event): void {
    ev.preventDefault();
    const healthDetail: FormData = new FormData();
    healthDetail.append('title', this.healthForm.value.title);
    healthDetail.append('content', this.healthForm.value.content);
    healthDetail.append('image', this.healthForm.value.image);
    healthDetail.append('status', this.healthForm.value.status ? '1' : '0');
    this.tags.forEach((tag) => {
      healthDetail.append('tags', tag.id.toString());
    });
    this.promoters.forEach((promoter) => {
      healthDetail.append('promoters', promoter.id.toString());
    });

    if (this.currentId) {
      this._healthService
        .updateArticle(healthDetail, this.currentId)
        .subscribe(article => {
          this._router.navigate(['/health/']);
          this._snackBar.open('Post creado correctamente', '', {
            duration: 3000,
          });
        });
    } else {
      this._healthService.createArticle(healthDetail).subscribe(article => {
        this._router.navigate(['/health/']);
        this._snackBar.open('Post actualizado correctamente', '', {
          duration: 3000,
        });
      });
    }
  }


  returnToList() {
    this._location.back();
  }

  openNewPromoterDialog() {
    const dialogRef = this._dialog.open(HealthAddPromoterComponent, {
      width: '800px',
    });
    const onAddedPromoters = dialogRef.componentInstance.onAddedPromoters.subscribe(
      (promoters: Promoter[]) => {
        this.promoters = this.mergeWithoutDuplicated(this.promoters, promoters);
        dialogRef.close();
      }
    );

    dialogRef.afterClosed().subscribe(() => {
      onAddedPromoters.unsubscribe();
    });
  }

  removePromoter(idx: number) {
    this.promoters.splice(idx, 1);
  }

  private getIds(tags: Tag[]) {
    return tags.map(tag => {
      return tag.id;
    });
  }

  mergeWithoutDuplicated(...arrays): Promoter[] {
    let jointArray = [];
    arrays.forEach((entireArray: Array<Promoter>) => {
      jointArray = [...jointArray, ...entireArray];
    });
    const mergedArray = jointArray.filter((promoter: Promoter, idx) => {
      const foundIdx = jointArray.findIndex((e: Promoter) => {
        return e.id === promoter.id;
      });
      return idx === foundIdx;
    });
    return mergedArray;
  }
}
